<template>
  <div id="content" v-if="entity">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
        </p>
        <h1 v-if="entity.name">{{ entity.name }}</h1>
      </div>
      <div class="responsiveTabs r-tabs" v-if="entity">
        <ul class="tabs">
          <li :class="getActiveTabClass('settings')">
            <a @click.prevent.stop="activateTab('settings')" v-translate>Vlastnosti</a>
          </li>
          <li :class="getActiveTabClass('liveweb')">
            <a @click.prevent.stop="activateTab('liveweb')" v-translate>Nastavení LiveWebu</a>
          </li>
          <li :class="getActiveTabClass('operators')" v-if="$_loggedUser_action_allowed('operators')">
            <a @click.prevent.stop="activateTab('operators')" v-translate>Operátoři</a>
          </li>
          <li :class="getActiveTabClass('domains')" v-if="$_loggedUser_action_allowed('brandDomains')">
            <a @click.prevent.stop="setActiveTab('domains')" v-translate>Domény</a>
          </li>
        </ul>
        <div class="tabs_content" v-show="isActiveTab('settings')">
          <BasicInfo :entity.sync="entity" :is-editable="$_updateActionAllowed" ref="basicinforef" />
          <ShopUrls :entity.sync="entity" :is-editable="$_updateActionAllowed" ref="shopurlref" />
          <QrCodePairing :entity="entity" :is-editable="$_updateActionAllowed" ref="qrcodepairingref" />
        </div>
        <div class="tabs_content" v-show="isActiveTab('liveweb')">
          <LivewebSettings
              :entity.sync="entity"
              :is-editable="$_updateActionAllowed"
              ref="livewebref" />
        </div>
        <div class="tabs_content" v-if="isActiveTab('operators') && $_loggedUser_action_allowed('operators')" key="operator_tab">
          <OperatorList
              :entity.sync="entity"
              ref="operatorsref" />
        </div>
        <div class="tabs_content" v-show="isActiveTab('domains') && $_loggedUser_action_allowed('operators')" >
          <domain-list
              :entity.sync="entity"
              ref="domainsref" @delete-domain="deleteDomain"/>
        </div>

        <section class="buttons" v-if="!isActiveTab('operators') && !isActiveTab('domains')">
          <p>
            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
            <input
                v-if="$_updateActionAllowed"
                type="submit"
                :value="'Uložit' | translate"
                :class="['btn', { btn_inactive: !formIsValid }]"
                @click.prevent.stop="submitForm()">
          </p>
        </section>
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import brands from "@/components/views/brands/mixins/brands"
import BasicInfo from "./forms/BasicInfo";
import ShopUrls from "./forms/ShopUrls";
import LivewebSettings from "./forms/LivewebSettings";
import OperatorList from "./forms/OperatorList";
import DomainList from "./forms/DomainList";
import QrCodePairing from "./forms/QrCodePairing.vue";

export default {
  name: "BrandDetail",
  components: {
    DomainList,
    OperatorList,
    LivewebSettings,
    ShopUrls,
    BasicInfo,
    QrCodePairing,
  },
  mixins: [detailActions, brands],
  created(BrandService, BrandDomainService) {
    this.entityService = BrandService
    this.brandDomainService = BrandDomainService
    this.createdInit();

    this.entity = null;
  },
  mounted() {
    this.activateTab('settings');
  },
  methods: {
    setActiveTab(tabName) {
      if (tabName === "domains") {
        this.$refs["domainsref"].reactivateComponent();
      }

      this.activateTab(tabName);
    },
    getDefaultLiveWebSettings() {
      return {
        site_title: null,
        hide_sections: [],
        automatic_pairing: false,
        pair_by_pairing_code: false,
        client_zone_url: null,
        logout_url: null,
        alternative_login_screen_html: null,
        custom_login_screen_html: null,
        automatic_pairing_error_message_html: null,
        non_updatable_device_type_codes: [],
        non_deletable_device_type_codes: [],
        custom_links: [],
      }
    },
    getEntity() {
      this.setLoadingMessage()

      return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
          .then(data => {
            this.entity = this.fillEntityDefaultValues(data.brand)
            this.emptyMessage()
          })
          .then(() => {
            this.$refs['basicinforef'].validateFormRequiredFields()
          })
          .catch(function (error) {
            this.setErrorMessage(error['error_message'])
          }.bind(this))
    },
    fillEntityDefaultValues(entity) {
      this._.forEach(this.getDefaultLiveWebSettings(), (value, key) => {
        if (!entity['liveweb_settings'].hasOwnProperty(key) || entity.liveweb_settings[key] === null) {
          entity.liveweb_settings[key] = value;
        }
      });

      return entity;
    },
    updateEntity(params, redirect = false) {
      let updateParams = this._filterUpdateValues(this.filterFormParams({...params}));
      this.entityService.updateEntity(this.entity.id, updateParams)
          .then(() => {
            this.entity.liveweb_settings.custom_links = [];
            if (redirect === true) {
              this.redirect(this.moduleName)
            } else {
              this.emptyMessage()
              this.setSuccessMessage()
              this.getEntity()
            }
          })
          .catch(function (error) {
            this.setErrorMessage(this.processErrorMessage(error))
          }.bind(this))
    },
    _filterUpdateValues(entity) {
      this._.forEach(this.getDefaultLiveWebSettings(), (value, key) => {
        if (!entity['liveweb_settings'].hasOwnProperty(key) || entity.liveweb_settings[key] === '') {
           entity.liveweb_settings[key] = value;
        }
      });

      return entity;
    },
    deleteDomain(idDomain, showPopup = true) {
      if (showPopup) {
        this.showPopup(idDomain, 'delete', 'delete-domain')
      } else {

        this.brandDomainService.deleteEntity(idDomain, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
            .then(() => {
              this.setSuccessMessage()
              this.getEntity()

              this.$refs["domainsref"].reactivateComponent();
            })
            .catch(function (error) {
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    executePopupAction(value) {
      if (value === true) {
        if (this.getPopupAction === 'delete') {
          this.deleteEntity(false)
        } else if (this.getPopupAction === 'delete-domain') {
          this.deleteDomain(this.getPopupId, false)
        }
      }
      this.hidePopup()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/brands/BrandDetail.vue